import { render, staticRenderFns } from "./ITRAddressCard.vue?vue&type=template&id=58f44700&scoped=true&"
import script from "./ITRAddressCard.vue?vue&type=script&lang=ts&"
export * from "./ITRAddressCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f44700",
  null
  
)

export default component.exports